<mat-card class="mt-3">
  <mat-card-content class="context-assignment-card-content">
    <div class="d-flex align-items-center component-header">
      <div class="flex-fill text-center">
        <h6 class="m-0 blue-text">
          Assignments {{ variation?.variationLabel === 'Base Item' ? null : '(' + assignments?.length + ')' }}
        </h6>
      </div>

      @if (!hideButtons && isSuperAdmin && variation?.variationLabel !== 'Base Item') {
        <div
          class="float-end button-position"
          >
          <button
            mat-raised-button
            class="add-modifier-btn"
            type="button"
            (click)="onCreateAssignment()"
            matTooltip="Add an assignment for this variation"
            >
            <mat-icon>add</mat-icon>
            Add
          </button>
        </div>
      }
    </div>
    <mat-divider class="card-divider"></mat-divider>

    <!-- Loading State -->
    @if (isLoading$ | async) {
      <div class="d-flex justify-content-center align-items-center p-5">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
    }

    <!-- Content State -->
    @if (!(isLoading$ | async)) {
      @if (variation?.variationLabel !== 'Base Item') {
        <div>
          @for (assignment of assignments; track assignment; let i = $index) {
            <div class="accordion-container">
              <mat-accordion>
                <mat-expansion-panel [expanded]="true">
                  <mat-expansion-panel-header>
                    <mat-panel-title
                      matTooltip="This variation is applied and reused on instances of this item under the following conditions">
                      <mat-icon class="me-1">grain
                      </mat-icon>
                      Assignment {{ i + 1 }}
                    </mat-panel-title>
                    @if (!hideButtons && isSuperAdmin) {
                      <button mat-icon-button
                        class="ms-auto"
                        matTooltip="Edit Assignment {{ i + 1}}"
                        (click)="$event.stopPropagation(); onEditAssignment(assignment)">
                        <mat-icon>edit</mat-icon>
                      </button>
                    }
                  </mat-expansion-panel-header>
                  <mat-divider class="mb-3"></mat-divider>
                  <mat-panel-description class="d-flex flex-column">
                    <p style="padding: 5px">This is applied to
                      the {{ assignment.consumer }} {{ assignment.locationId }}
                    menu for the following instances:</p>
                    <ul>
                      @for (property of assignment?.properties | keyvalue; track property) {
                        <li>
                          <ng-container>
                            {{ formatPropertyKey(property.key) }}: {{ property.value }}
                          </ng-container>
                        </li>
                      }
                    </ul>
                  </mat-panel-description>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
          }
        </div>
      } @else {
        <div class="d-flex justify-content-center align-items-center">
          <p class="mt-4 text-center">{{ itemTag }} is the default</p>
        </div>
      }
    }
  </mat-card-content>
</mat-card>
